import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextArea } from '@/app/components/form/TextArea';
import type { CreateClientFormData } from '@/types/clientsApiTypes';

interface DietaryRestrictionsProps {
  onUpdateFormData?: (fieldName: string, fieldValue: unknown) => void;
}

export const DietaryRestrictions = ({ onUpdateFormData }: DietaryRestrictionsProps) => {
  const handleSaveOnBlur = (name: string, value: unknown) => {
    onUpdateFormData?.(name, value);
  };

  const basePath = `primary_passenger.preference_data`;
  const {
    register,
    formState: { errors },
  } = useFormContext<CreateClientFormData>();
  return (
    <div className="mt-4">
      <TextArea
        {...register(`${basePath}.allergies`)}
        disableResize
        label=""
        placeholder="e.g. nut allergy, gluten-free, lactose intolerance"
        rows={4}
        errors={errors}
        onBlur={(e) => handleSaveOnBlur(e.target.name, e.target.value)}
      />
    </div>
  );
};
